import React from 'react';
import {useParams} from 'react-router-dom';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {ItemAssignmentForm} from 'src/app/item-tracker/ItemAssignmentForm';
import {itemAssignmentDocumentTitle} from 'src/app/item-tracker/itemAssignmentHelpers';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

const ItemAssignmentCreatePage: React.FC = () => {
  useSetDocumentTitle(`${itemAssignmentDocumentTitle} - Create`);
  const {definitionId} = useParams();

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.ItemTracker}>
      {definitionId !== undefined && (
        <ItemAssignmentForm
          definitionId={Number(definitionId)}
          mode="create"
          enableEdit={true}
          enableTransitions={true}
        />
      )}
    </ContentWrapper>
  );
};

export default ItemAssignmentCreatePage;

routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.ItemAssignmentCreate(':definitionId'),
  element: <ItemAssignmentCreatePage />,
  isPrivate: true,
  module: ModuleEnum.ItemTrackerAssignments,
  operation: PermissionOperationEnum.Create,
});
